/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGenerateBarcode = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2a9 9 0 0 1 .265 17.996L12 20h-.586l1.293 1.293-1.414 1.414L7.586 19l3.707-3.707 1.414 1.414L11.414 18H12a7 7 0 1 0-5.521-2.696l.196.24-1.52 1.299A9 9 0 0 1 12 2zm3.832 6.078v.616l-.964 1.053c.363.044.642.178.838.403.196.226.294.508.294.847 0 .299-.063.557-.19.774a1.25 1.25 0 0 1-.547.5 1.905 1.905 0 0 1-.843.173c-.213 0-.418-.022-.616-.068a1.93 1.93 0 0 1-.527-.2v-.796c.153.087.33.156.533.206s.394.075.577.075c.265 0 .468-.058.61-.174.142-.115.213-.28.213-.496 0-.204-.055-.361-.165-.473-.11-.111-.272-.167-.485-.167-.194 0-.384.038-.571.113l-.275-.49 1.009-1.137H13.35v-.76zm-6.022 0v4.289h-.88v-3.17L8 9.53v-.55l1.188-.903zM11.569 8c.433 0 .769.106 1.008.317.24.211.359.512.359.903 0 .16-.03.32-.09.479-.06.16-.158.338-.294.535a9.73 9.73 0 0 1-.552.709l-.566.664h1.513v.76h-2.65v-.628l1.02-1.197c.197-.231.352-.42.462-.565.11-.146.187-.27.232-.37s.067-.197.067-.285c0-.363-.214-.544-.644-.544-.302 0-.646.11-1.03.329v-.802A2.539 2.539 0 0 1 11.568 8z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgGenerateBarcode as GenerateBarcode };
